module.exports = __webpack_public_path__ + "static/media/mail-sent-illustration.b7e622dd.svg";